import Account from "@/helper/AccountHelper.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import ConfigManager from '@/config/ConfigManager.js';
import { map } from 'rxjs/operators';

/**
 * @method apiRedeemCampaign
 */
export default {
    /**
     * @param {String|Number} campaignId
     * @param {Object} redeemParams
     * @param {String|Number} redeemQuantity
     */
    apiRedeemCampaign: function (campaignId, redeemParams, redeemQuantity, isSurvey = false) {
        let token = Account.getToken();
        var params = {...redeemParams};
        var url;
        if (params.info3) {
            url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/redeem?info3=${params.info3}`;
        } else {
            url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/redeem`;
        }

        if (isSurvey){
            url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/redeem`;
        }

        if (!isNaN(redeemQuantity) && redeemQuantity > 1) {
            params.sp_points = redeemQuantity;
            // params.quantity = redeemQuantity;
            // url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/bulkredeem`;
        }
        return  BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    },

    /**
     * Update delivery address after redeem campaign delivery completed.
     * @param {string} redeemKey redeem key return from redeem api or history api
     * @param {AddressRedeemModel} params /core/Redeem/config/UpdateAfterRedeemModel.js
     */
    apiUpdateAddressAfterRedeem: function(redeemKey, params) {
        let token = Account.getToken();
        let url = ConfigManager.getApiUrl() + `/redeem/${redeemKey}/address`;
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    },
}
